export function helpLink() {
  window.open("https://www.dalyexercise.ie/app-contact/", "_blank");
}
